import React from 'react';
import {useTranslation} from "react-i18next";

export default function SectionSmallTitle({title, marginBottom, textAlign}) {
    const {t} = useTranslation();
    return <div className={`text-${textAlign} section_small_title`} style={{marginBottom: marginBottom}} data-aos="fade-down" data-aos-duration="1500">{t(title)}</div>
}